import { AgxSpacer } from '@urbanx/agx.ui-components2';
import { ReactNode } from 'react';

const CampaignOverviewInfoCard = ({ children }: { children: ReactNode }) => (
  <AgxSpacer
    className="campaignOverviewInfoCard"
    contentJustification="center"
    gap="spacing-xl"
    padding="spacing-xl"
  >
    {children}
  </AgxSpacer>
);

export default CampaignOverviewInfoCard;
